<!-- =========================================================================================
     Author: Jose Martin de la Cruz Vicencio
========================================================================================== -->

<template>

    <div id="data-list-list-view" class="data-list-container">

        <vs-popup fullscreen  title="Documentos Inscripcion:" :active.sync="popupActiveDocumentos2">
<table>
    <tr> 
        <td style="padding: 25px;"> 
            <h1>Solicitud Inscripción</h1>
            <iframe align="left" :src="`https://cdn.upbicentenario.edu.mx/candidatos_1_2021/${datos_candidato.solicitudInscripcion}`" height="550px" width="900px" ></iframe>
        </td>  
        <td>
            <h1>Certificado Bachillerato</h1>
            <iframe align="right" :src="`https://cdn.upbicentenario.edu.mx/candidatos_1_2021/${datos_candidato.certificadoBachillerato}`"  height="550px" width="900px"  ></iframe>
         </td> 
    </tr>

       <tr> 
        <td style="padding: 25px;"> 
           <h1>Examen Medico</h1>
           <iframe align="left" :src="`https://cdn.upbicentenario.edu.mx/candidatos_1_2021/${datos_candidato.examenMedico}`"  height="550px" width="900px"  ></iframe>
        </td>  
        <td>
            <h1>Carta Conducta</h1>
            <iframe align="right"  :src="`https://cdn.upbicentenario.edu.mx/candidatos_1_2021/${datos_candidato.cartaConducta}`"  height="550px" width="900px" ></iframe>
         </td> 
    </tr>

    <tr>
        <td style="padding: 25px;">
            <h1>Comprobante Domicilio</h1>
            <iframe  align="left" :src="`https://cdn.upbicentenario.edu.mx/candidatos_1_2021/${datos_candidato.comprobanteDomicilio}`"  height="550px" width="900px" ></iframe>
        </td>
        <td>
        <h1>Folio Suredsu</h1>
        <iframe align="right" :src="`https://cdn.upbicentenario.edu.mx/candidatos_1_2021/${datos_candidato.folioSuredsu}`" height="550px" width="900px" ></iframe>
        </td>
    </tr>

    <tr>
        <td style="padding: 25px;">
        <h1>Codigo Etica</h1>
        <iframe  align="center" :src="`https://cdn.upbicentenario.edu.mx/candidatos_1_2021/${datos_candidato.codigoEtica}`"  height="550px" width="900px" ></iframe>
        </td>
        </tr>

    </table>                

        </vs-popup>


 <vx-card title=""> 

 <div class="container text-center">
  <div class="row">
    <div class="col-4"> Fecha Examen de Admisión
                   <v-select label="fecha" placeholder="Seleccione una Fecha a buscar" @change="onChangeFechas()" v-model="fecha_admision" :options="fechas_examen">
                    </v-select>   
                    <!-- {{fecha_admision.id}} -->
    </div>
     <div class="col-2">
      
         <div v-show="cantidad_aspirantes_fecha>1" class="alert alert-info" role="alert"> Total de aspirantes: <b>{{cantidad_aspirantes_fecha}}  </b> </div>
    </div>

    <div class="col-4"> Carreras
                   <!-- <v-select label="fecha" placeholder="Seleccione una Fecha a buscar" @change="onChangeFechas(fecha_admision.id)" v-model="fecha_admision" :options="fechas_examen">
                    </v-select>    -->
                    <v-select class="float-left" @change="onChangeCarreraList()" style="width: 100%;" label="nombre" v-model="carreraListSelected" :options="carreras"></v-select>
                    <!-- {{carreraListSelected.id}} -->
    </div>

  </div>

</div>
<br>

<h3>    Documentos de aspirantes a inscripción </h3>

  </vx-card> 

        <vs-table ref="table" pagination :max-items="180" stripe search :data="aspirantes">
            
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <!-- ITEMS PER PAGE -->
            </div>

            <template slot="thead">

                <vs-th>Número</vs-th>
                <vs-th sort-key="idCandidato">ID(Ficha)</vs-th>
                <vs-th sort-key="curp">Curp</vs-th>
                <vs-th>Correo</vs-th>
                <vs-th>Nombre</vs-th>
                <!-- <vs-th>Fecha De Registro</vs-th> -->
                <!-- <vs-th>Fecha De Modificacion</vs-th> -->
                <vs-th sort-key="sigla">Carrera</vs-th>
                <vs-th>Descargar expediente</vs-th>
                <vs-th>Opciones</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td>
                        <p class="product-name font-medium">{{ indextr + 1 }}</p>
                    </vs-td>


                    <vs-td>
                        <p class="product-name font-medium">{{ tr.idCandidato }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="product-category">{{ tr.curp }}</p>
                    </vs-td>
                    <vs-td>
                        {{ tr.correo }}
                    </vs-td>
                   <vs-td>
                        <p> {{tr.nombreCandidato}}</p>
                    </vs-td>
                  <!--   <vs-td>
                        <p class="product-category">{{ tr.fecha_registro }}</p>
                    </vs-td>
                         <vs-td>
                        <p class="product-category">{{ tr.fecha_modificacion }}</p>
                    </vs-td>
                         -->
                     <vs-td>
                        <p class="product-category">{{ tr.sigla }}</p>
                    </vs-td> 
                    <vs-td v-if="tr.action == 1">

                        <vs-button @click="cambiar_estatus(tr.statusId, tr.idCandidato)" size="small" color="primary" type="gradient">
                        {{tr.statusDescripcion}}</vs-button>

                    </vs-td>
                    <vs-td v-else>
                        
                        <vs-button size="small" color="success" type="border">{{tr.statusDescripcion}}</vs-button>


                    </vs-td>

                    <vs-td :data="tr.idCandidato">
                        <vs-button size="small" @click="detalles_candidato(tr.idCandidato)" color="success" type="gradient">Ver Ficha</vs-button>
                    </vs-td>


                </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>

</template>

<script>
    import vSelect from 'vue-select'
    export default {
        data() {
            return {
                 id_rol: this.getKey('id_rol'), 
                id: 0,
                status_actual: 0,
                aspirantes: [],
                selected: [],
                users: [],
                itemsPerPage: 500,
                isMounted: false,
                addNewDataSidebar: false,

                popupActiveCeneval:false,
                popupActiveDatos:false,
                popupActiveDocumentos:false,
                popupActivePago:false,
                popupActiveDocumentos2:false,

                folio_ceneval: '',
                rechazo_datos: '',
                rechazo_documentos: '',
                rechazo_documentos2: '',
                NoCertificado:'',
                datos_candidato: '[{}]',
                fechas_examen:[],
                fecha_admision:{},
                cantidad_aspirantes_fecha:'',
                carreras: [],
                carreraListSelected:{},
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx;
                }
                return 0;
            },
        },
        components: {
            'v-select': vSelect
        },
        created() {
          if(this.id_rol == 1 || this.id_rol == 5){
           
                this.getFechasExamen();
                this.getCarreras();
   }
        },
        mounted() {
            this.isMounted = true;
        },
        watch: {
            // whenever question changes, this function will run
            status_actual: function(){
               // alert(this.status_actual);
                this.muestra_modal();
            },
        },

        methods: {
                
                getCarreras() {
      this.$http.get("carreras").then(
          response => {
            // console.log(response.data)
            this.carreras = response.data.carreras;
            //console.log(this.kardex);

          },
          error => {
            this.StepError(error);
          }
      );
      this.$http.get("carrera_id/" + this.carrera).then(
          response => {
            // console.log(response.data)
            this.carreras_select = response.data.carrera[0];
            //console.log(this.kardex);

          },
          error => {
            this.StepError(error);
          }
      );
    },

            onChangeCarreraList:function(){
        //    console.log(idCarrera_select)
                  this.getAspirantes();  

              
            },

            onChangeFechas:function () {
                     this.getAspirantes();  
                    //  this.selectedCandidatos=[];                          
            },
            getFechasExamen() {
                this.$http.get("fechasAdmisionTodas").then(
                    response => {     
                        this.fechas_examen = response.data.fechasAdmisionTodas;
                          },
                    error => {
                        this.steperror(error);
                    }
                );
            },

            ver_archivo(nombre_archivo){
                window.open('https://cdn.upbicentenario.edu.mx/candidatos_1_2021/' + nombre_archivo);
            },
            cambiar_estatus(status, idc){
                this.status_actual = status;
                this.id = idc;
                // para limpiar los campos al momento de  volver a abrir el popup
                    this.rechazo_documentos2='';
                        this.NoCertificado='';
         

            },
   
            get_datos_candidato(){
                this.$http.get("get_datos_candidatos_aceptados/" + this.id).then(
                    response => {
                           this.datos_candidato = response.data.datos_documentos[0];
                     },
                    error => {
                        this.steperror(error);
                    }
                );
            },
            muestra_modal(){

                  if(this.status_actual == 2){
                    this.get_datos_candidato()
                    this.popupActiveDocumentos2 = true;
                    this.status_actual = false;
                    
                }


            },
            detalles_candidato(idficha){
                window.open('https://cdn.upbicentenario.edu.mx/api/pdf_ficha/' + idficha)
            },


            // getAspirantes () {
            //     this.$http.get("descargar_documentos_candidatos_aceptados").then(
            //         response => {
            //             this.aspirantes = response.data.descargar_aspirantes_aceptados;

            //         },
            //         error => {
            //             this.steperror(error);
            //         }
            //     );
            // }

            getAspirantes(){
               var idf='';
                var idCarrera_select='';
                   idf = this.fecha_admision.id;
                   idCarrera_select = this.carreraListSelected.id;

                this.$http.post("descargar_documentos_candidatos_aceptados",{idfecha:idf,idCarrera:idCarrera_select}).then(
                        response => {
                        this.aspirantes = response.data.descargar_aspirantes_aceptados;
                        // console.log(this.aspirantes_fecha);
                                //   document.getElementById("btn_rubrica").style.display = "block";
                                //     document.getElementById("btn_rubrica2").style.display = "block";
                                //     document.getElementById("btn_excel").style.display = "block";    
                        this.cantidad_aspirantes_fecha= this.aspirantes.length;
                    },
                    error => {
                        this.steperror(error);
                    }
                );
            },
           
        },
    }
</script>